/**
 * Returns a gradient avatar URL routed through Next.js image optimisation.
 * Next.js fetches from avatar.vercel.sh once and re-serves with a 1-year
 * immutable cache header, bypassing the CDN's max-age=0 response.
 *
 * Each consuming app must add avatar.vercel.sh to its next.config remotePatterns.
 */
export function getGradientAvatarUrl(
  identifier: string,
  width: 32 | 40 | 96 = 96
): string {
  const origin = `https://avatar.vercel.sh/${identifier}`;
  return `/_next/image?url=${encodeURIComponent(origin)}&w=${width}&q=75`;
}
